export default __webpack_public_path__ + "static/media/Snd1.b82c2335.mp3";